import { exhaustiveFail } from '@cbridge-utils/error';
import { IApiPricingProfile, IApiPricingProfileUpdate, ApiPricingMode, ApiAggregationMethod } from '@cbridge-packages/api';
import { IPricingProfile, IPricingProfileForm, PricingMode, AggregationMethod } from './pricingProfile.interface';

export namespace PricingProfileTranslator {
  export function fromApi(profile: IApiPricingProfile): IPricingProfile {
    return {
      id: profile.id,
      name: profile.name,
      mode: PricingProfileTranslator.fromApiPricingMode(profile.mode),
      aggregationMethod: profile.aggregationMethod
        ? PricingProfileTranslator.fromApiAggregationMethod(profile.aggregationMethod)
        : undefined,
      lps: profile.lps?.map(({ id: value, name: label }) => ({ value, label })),
    };
  }

  export function fromApiPricingMode(mode: ApiPricingMode): PricingMode {
    switch (mode) {
      case ApiPricingMode.FAILOVER:
        return PricingMode.SymbolFailover;
      case ApiPricingMode.EXCHANGE:
        return PricingMode.LpFailover;
      case ApiPricingMode.BASIC_AGGREGATION:
        return PricingMode.BasicAggregation;
      default:
        return exhaustiveFail(mode);
    }
  }

  export function fromApiAggregationMethod(method: ApiAggregationMethod): AggregationMethod {
    switch (method) {
      case ApiAggregationMethod.SUM_VOLUMES:
        return AggregationMethod.SumVolumes;
      case ApiAggregationMethod.SEPARATE_LP:
        return AggregationMethod.SeparateLP;
      default:
        return exhaustiveFail(method);
    }
  }

  export function toApi(profile: IPricingProfileForm): IApiPricingProfileUpdate {
    const isBasicAggregation = profile.mode === PricingMode.BasicAggregation;

    return {
      id: profile.id,
      name: profile.name,
      mode: PricingProfileTranslator.toApiPricingMode(profile.mode),
      aggregationMethod: isBasicAggregation && profile.aggregationMethod
        ? PricingProfileTranslator.toApiAggregationMethod(profile.aggregationMethod)
        : undefined,
      lps: profile.lps
        .filter(item => item.lp !== undefined)
        .map(item => item.lp.value),
    };
  }

  export function toApiPricingMode(mode: PricingMode): ApiPricingMode {
    switch (mode) {
      case PricingMode.SymbolFailover:
        return ApiPricingMode.FAILOVER;
      case PricingMode.LpFailover:
        return ApiPricingMode.EXCHANGE;
      case PricingMode.BasicAggregation:
        return ApiPricingMode.BASIC_AGGREGATION;
      default:
        return exhaustiveFail(mode);
    }
  }

  export function toApiAggregationMethod(method: AggregationMethod): ApiAggregationMethod {
    switch (method) {
      case AggregationMethod.SumVolumes:
        return ApiAggregationMethod.SUM_VOLUMES;
      case AggregationMethod.SeparateLP:
        return ApiAggregationMethod.SEPARATE_LP;
      default:
        return exhaustiveFail(method);
    }
  }
}
